import Box from "@mui/material/Box";
import {
  ChipAIGeneratedAnySection,
  ChipAIGeneratedSection,
} from "./ChipAIGenerated";

const headingRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
};

const SectionHeading = ({ basePath, section, sections, children, sx = {} }) => (
  <Box sx={{ ...headingRowSx, ...sx }}>
    {children}
    {basePath && Array.isArray(sections) && sections.length > 0 ? (
      <ChipAIGeneratedAnySection basePath={basePath} sections={sections} />
    ) : basePath && section ? (
      <ChipAIGeneratedSection basePath={basePath} section={section} />
    ) : null}
  </Box>
);

export default SectionHeading;
